import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-35209d31"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu-cart" }
const _hoisted_2 = { class: "products-list product-list-in-card pl-2 pr-2" }
const _hoisted_3 = { class: "product-img" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "product-info" }
const _hoisted_6 = {
  href: "javascript:void(0)",
  class: "product-title"
}
const _hoisted_7 = { class: "product-description" }
const _hoisted_8 = { class: "product-description" }
const _hoisted_9 = { class: "item" }
const _hoisted_10 = { class: "bottom-cart" }
const _hoisted_11 = { class: "bold" }
const _hoisted_12 = { class: "bold" }
const _hoisted_13 = { class: "item" }
const _hoisted_14 = { class: "bottom-cart" }

import store from "@/store";
import cardUtils from '@/utils/CardUtils';

import Utils from "@/utils/Utils";
import { ref, onMounted, watch, computed, createVNode } from "vue";
import { useRoute, useRouter } from "vue-router";
import MoneyView from '@/components/money/text/MoneyView.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'CartMenu',
  setup(__props) {

const router = useRouter();
const orderList = ref([]);
const quantity = ref(0);
const money = ref(0);
const moneyShip = ref(0);
const totalMoney = ref(0);
onMounted(async () => {
    await loadCart();
});
const loadCart = () => {

    const dataList = cardUtils.getLcCart() || [];
    // reset trước khi tính
    totalMoney.value = 0;
    quantity.value = 0;

    for (let i = 0; i < dataList.length; i++) {

        const item = dataList[i];
        const price = item.minPrice ?? 0;
        const qty = item.quantity ?? 0;
        const itemTotal = qty > 0 ? price * qty : 0;
        totalMoney.value += itemTotal;
        quantity.value += qty;
        dataList[i].totalPrice = itemTotal; 
    }

    orderList.value = dataList;
};
const viewCart = () => {
    router.push({ path: "/cart" });
};
const payCart = () => {
    router.push({ path: "/payment" });
};
const isLoadCart = computed(() => {
    return store.getters.isLoadCart;
});
watch(isLoadCart, async (newValue, oldValue) => {
    await loadCart();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderList.value, (item, index) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "item",
          key: index
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              src: item.imageDetail,
              alt: "Product Image",
              class: "img-size-50"
            }, null, 8, _hoisted_4)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("a", _hoisted_6, _toDisplayString(item.productName), 1),
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('cart.quantity')) + ": " + _toDisplayString(item.quantity), 1),
            _createElementVNode("span", _hoisted_8, [
              _createTextVNode(_toDisplayString(_ctx.$t('cart.price')) + ": ", 1),
              _createVNode(MoneyView, {
                curency: item.currency,
                money: item.totalPrice
              }, null, 8, ["curency", "money"])
            ])
          ])
        ]))
      }), 128)),
      _createElementVNode("li", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('cart.quantity')) + ": " + _toDisplayString(quantity.value), 1),
          _createElementVNode("span", _hoisted_12, [
            _createTextVNode(_toDisplayString(_ctx.$t('cart.total')) + ": ", 1),
            _createVNode(MoneyView, { money: totalMoney.value }, null, 8, ["money"])
          ])
        ])
      ]),
      _createElementVNode("li", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", {
            onClick: viewCart,
            class: "btn-cart-order cart-view"
          }, _toDisplayString(_ctx.$t('cart.viewCart')), 1),
          _createElementVNode("div", {
            onClick: payCart,
            class: "btn-cart-order cart-pay"
          }, _toDisplayString(_ctx.$t('cart.checkout')), 1)
        ])
      ])
    ])
  ]))
}
}

})